/* vpb-analytics.js — first-party funnel telemetry for lushlobster.com.
 *
 * Captures: session (30-min inactivity window), landing attribution
 * (utm_* + gclid, first non-empty wins per session), page views typed by
 * template, checkout starts, and the add-something-sweet → reminders
 * pass-through. Also stamps the session id + attribution onto the cart as
 * attributes so every ORDER joins back to its session/campaign in Shopify.
 *
 * Exposes window.vpbTrack(event, props) for the card-customiser bundle
 * (editor_enter/complete, drawer + gift-rail events). Fire-and-forget:
 * batched, sendBeacon on pagehide, text/plain bodies (no CORS preflight),
 * and every call is try/caught — telemetry can never break the storefront.
 * No PII is collected.
 *
 * ⚠ DO NOT REMOVE from the theme — /metrics + the web_events pipeline
 * depend on this file and the include at the bottom of layout/theme.liquid.
 */
(function () {
  var EP = 'https://va.lushlobster.com/api/track';
  var now = Date.now();

  // ── session (GA-style: new after 30 min inactivity) ──
  var sid = null, last = 0;
  try {
    sid = localStorage.getItem('vpb_sid');
    last = Number(localStorage.getItem('vpb_last')) || 0;
  } catch (e) { /* private mode */ }
  var fresh = !sid || (now - last) > 30 * 60 * 1000;
  if (fresh) sid = now.toString(36) + Math.random().toString(36).slice(2, 10);
  try {
    localStorage.setItem('vpb_sid', sid);
    localStorage.setItem('vpb_last', String(now));
  } catch (e) { /* no-op */ }

  // ── attribution: query params win; else keep the session's stored one ──
  var qs = new URLSearchParams(location.search);
  var attr = null;
  try { attr = JSON.parse(localStorage.getItem('vpb_attr') || 'null'); } catch (e) { /* no-op */ }
  if (fresh) attr = null; // new session starts attribution afresh
  var qa = {
    s: qs.get('utm_source'), m: qs.get('utm_medium'), c: qs.get('utm_campaign'),
    t: qs.get('utm_term'), n: qs.get('utm_content'), g: qs.get('gclid'),
    f: qs.get('fbclid'),
    w: qs.get('wbraid'), b: qs.get('gbraid'), // Google Ads iOS click ids (9 Oct 2026)
    k: qs.get('msclkid'), tt: qs.get('ttclid') // Microsoft Ads + TikTok click ids (LL-0232/0233, 9 Oct 2026)
  };
  if (qa.f) qa.ft = Date.now(); // fbc click-id format needs the capture time
  if (qa.s || qa.g || qa.c || qa.f || qa.w || qa.b || qa.k || qa.tt) {
    attr = qa;
    try { localStorage.setItem('vpb_attr', JSON.stringify(attr)); } catch (e) { /* no-op */ }
  }
  attr = attr || {};

  var device = /Mobi|Android|iPhone|iPad/.test(navigator.userAgent) ? 'mobile' : 'desktop';
  var signedIn = typeof window.vpbSignedIn === 'boolean' ? window.vpbSignedIn : null;

  function pageType(p) {
    p = p || location.pathname;
    if (p === '/' || p === '') return 'home';
    // PDPs opened from a grid live at /collections/<handle>/products/<handle>,
    // so a bare startsWith('/products/') mislabelled ~8% of card views as
    // "collection" (fixed 27 Aug 2026).
    if (p.indexOf('/products/') !== -1) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/add-something-sweet') === 0) return 'ass';
    if (p.indexOf('/pages/gifts') === 0) return 'gifts';
    if (p.indexOf('/pages/reminders') === 0) return 'reminders';
    if (p.indexOf('/pages/account') === 0 && p.indexOf('/pages/account-') !== 0) return 'account';
    if (p.indexOf('/cart') === 0) return 'cart';
    return 'other';
  }

  // ── batched transport ──
  var q = [], timer = null;
  function flush(useBeacon) {
    if (!q.length) return;
    var body = JSON.stringify({ events: q.splice(0, q.length) });
    try {
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }));
        return;
      }
      fetch(EP, { method: 'POST', body: body, keepalive: true });
    } catch (e) { /* never break the page */ }
  }
  // quiet = true: passive events (page_leave, web_vitals) that must not refresh the
  // 30-minute session clock, so sessions are counted exactly as before.
  function track(ev, props, quiet) {
    try {
      props = props || {};
      // wbraid/gbraid ride in props (JSON column) so the collector needs no schema change.
      if (attr.w && !props.wbraid) props.wbraid = attr.w;
      if (attr.b && !props.gbraid) props.gbraid = attr.b;
      if (attr.k && !props.msclkid) props.msclkid = attr.k;
      if (attr.tt && !props.ttclid) props.ttclid = attr.tt;
      if (attr.f && !props.fbclid) props.fbclid = attr.f; // LL-0234 (10 Oct 2026)
      // Signed-in state from Liquid `customer` (layout/theme.liquid sets
      // window.vpbSignedIn; 20 Oct 2026). Never an id, email or name.
      if (typeof signedIn === 'boolean' && props.signed_in === undefined) props.signed_in = signedIn;
      q.push({
        sid: sid, event: ev, path: location.pathname, page_type: pageType(),
        device: device, referrer: document.referrer || null,
        utm_source: attr.s || null, utm_medium: attr.m || null,
        utm_campaign: attr.c || null, utm_term: attr.t || null,
        utm_content: attr.n || null, gclid: attr.g || null,
        props: props, ts: new Date().toISOString()
      });
      if (!quiet) localStorage.setItem('vpb_last', String(Date.now()));
      clearTimeout(timer);
      timer = setTimeout(function () { flush(false); }, 1200);
    } catch (e) { /* no-op */ }
  }
  window.vpbTrack = track;
  // Manual beacon-flush for callers whose events fire during tab-hide AFTER
  // our own hidden/pagehide flush has already run (listener order = register
  // order, and the customiser bundle registers later than this script). The
  // editor's abandon telemetry calls this so the event isn't stranded in the
  // queue past the beacon window.
  window.vpbFlush = function () { flush(true); };

  if (fresh) track('session_start', { landing: (location.pathname + location.search).slice(0, 180) });
  track('page_view');

  // ── account sign-ins (Alex, 20 Oct 2026) ──
  // account_sign_in: the shopper is signed in on this page AND either arrived
  // from Shopify's sign-in (referrer shopify.com, *.account.myshopify.com or a
  // /customer_authentication URL) or this browser last saw them signed out.
  // Arrivals from Shopify count once per tracker session, so reloads and
  // hops back from the hosted account pages don't add logins.
  // account_first_sign_in: additionally, when this browser has never seen a
  // signed-in page before (browser-level: a new device or cleared storage
  // counts as a first sign-in). A shopper who was already signed in before this
  // shipped is recorded silently (no event) on their first signed-in page.
  (function () {
    if (signedIn === null) return;
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); return true; } catch (e) { return false; } }
    if (!signedIn) { set('ll_auth_state', '0'); return; }
    var prev = get('ll_auth_state'), ever = get('ll_auth_ever'), lastSid = get('ll_auth_si_sid');
    var ref = document.referrer || '', refHost = '';
    try { refHost = ref ? new URL(ref).hostname : ''; } catch (e) { /* no-op */ }
    var fromShopify = refHost === 'shopify.com' ||
      /\.account\.myshopify\.com$/.test(refHost) || ref.indexOf('customer_authentication') !== -1;
    // shopify.com sends only its origin as referrer, so an already-signed-in shopper returning from
    // order status / Shop looks the same as a fresh sign-in: trust the referrer only for a browser we
    // have never seen (review, 20 Oct 2026). Real sign-ins start on a signed-out page → was_signed_out.
    var via = prev === '0' ? 'was_signed_out' : (prev === null && fromShopify && lastSid !== sid ? 'shopify_referrer' : '');
    // Storage blocked: every arrival would look new, so record nothing rather than over-count.
    if (!set('ll_auth_state', '1')) return;
    set('ll_auth_ever', '1');
    if (!via) return;
    set('ll_auth_si_sid', sid);
    track('account_sign_in', { via: via, ref_host: refHost.slice(0, 60), pt: pageType() });
    if (!ever) track('account_first_sign_in', { via: via, scope: 'browser' });
  })();

  // ── checkout starts + interstitial proceed clicks (capture phase) ──
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('a[href*="/checkout"], button[name="checkout"]')) {
      track('checkout_start', { from: pageType() }); flush(true);
    } else if (t.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"]')) {
      // Express wallets (Shop Pay / Apple Pay / Google Pay / PayPal) render inside
      // shadow DOM; the click retargets to the host element, so closest() on the
      // host is enough. Counted as checkout_start so express starts aren't missed.
      track('checkout_start', { from: pageType(), method: 'express' }); flush(true);
    } else if (t.closest('a[href*="/pages/reminders?proceed"]') && pageType() === 'ass') {
      // 10 Oct 2026: only the hand-over link; the header's Reminders links on this
      // page also point at /pages/reminders and were counted as ass_proceed.
      track('ass_proceed', {}); flush(true);
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/checkout/.test(f.getAttribute && (f.getAttribute('action') || ''))) {
      track('checkout_start', { from: pageType() }); flush(true);
    }
  }, true);
  addEventListener('pagehide', function () { flush(true); });
  // pagehide never fires on a plain tab-switch/app-switch (common on mobile);
  // visibilitychange→hidden is the last reliable moment to beacon there.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush(true);
  });

  // ── Klaviyo onsite forms → bundle-popup funnel ──
  // The "BUNDLES POP UP" form (id R4XwaL) advertises the bundle wizard; its
  // "Customize Now" CTA redirects to /pages/build-a-bundle. Klaviyo.js emits
  // window 'klaviyoForms' events for every onsite form — we map open →
  // bundle_popup_view and the CTA redirect → bundle_popup_cta, this form only,
  // so email-capture popups never pollute the bundle funnel.
  var BUNDLE_FORM_ID = 'R4XwaL';
  addEventListener('klaviyoForms', function (e) {
    try {
      var d = (e && e.detail) || {};
      if (String(d.formId) !== BUNDLE_FORM_ID) return;
      if (d.type === 'open' || d.type === 'embedOpen') {
        track('bundle_popup_view', { formId: d.formId });
      } else if (d.type === 'redirectedToUrl') {
        track('bundle_popup_cta', { formId: d.formId });
        flush(true); // page is about to navigate — don't lose the click
      }
    } catch (err) { /* no-op */ }
  });

  // ── stamp session + attribution onto the cart (joins ORDERS to sessions).
  //    Underscore-prefixed attributes surface in admin/API, not to customers. ──
  function stamp() {
    try {
      if (localStorage.getItem('vpb_stamped') === sid) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.item_count) return;
          if (c.attributes && c.attributes._vpb_sid === sid) {
            try { localStorage.setItem('vpb_stamped', sid); } catch (e) { /* no-op */ }
            return;
          }
          var attrs = { _vpb_sid: sid };
          if (attr.g) attrs._vpb_gclid = attr.g;
          if (attr.w) attrs._vpb_wbraid = attr.w;
          if (attr.b) attrs._vpb_gbraid = attr.b;
          if (attr.k) attrs._vpb_msclkid = attr.k;
          if (attr.tt) attrs._vpb_ttclid = attr.tt;
          if (attr.f) {
            attrs._vpb_fbclid = attr.f;
            if (attr.ft) attrs._vpb_fbclid_ts = String(attr.ft);
          }
          // _fbp exists only when the Meta pixel ran (consent given) — free
          // extra match quality for the server-side CAPI event.
          var fbp = (document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/) || [])[1];
          if (fbp) attrs._vpb_fbp = fbp;
          if (attr.s) attrs._vpb_utm_source = attr.s;
          if (attr.c) attrs._vpb_utm_campaign = attr.c;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).then(function () {
            try { localStorage.setItem('vpb_stamped', sid); } catch (e) { /* no-op */ }
          });
        });
    } catch (e) { /* no-op */ }
  }
  stamp();
  document.addEventListener('cart:refresh', stamp);
  setTimeout(stamp, 8000); // catch first add-to-cart shortly after landing

  // ── Field INP sample (2026-07-29 INP campaign) ──
  // Real interaction latencies via the Event Timing API; report the worst
  // per page on pagehide. Gives a SAME-DAY first-party INP scoreboard in
  // web_events instead of waiting on the 28-day CrUX window. interactionId
  // filters to real discrete interactions (taps/keys), like INP proper.
  // 1 Nov 2026 (p75 168 → 208 ms, and nothing said which tap or script): the worst interaction
  // also reports what was tapped (tgt), the event (et), its input delay / processing /
  // presentation split (d/pr/ps) and, where Long Animation Frames exist (Chrome), the script that
  // ran longest in that frame (src = host+path tail, inv = invoker such as "DIV.onclick").
  (function () {
    var worst = 0, n = 0, w = null, frames = [];
    function desc(el) {
      try {
        if (!el || !el.tagName) return '';
        var d = el.tagName.toLowerCase();
        if (el.id) return (d + '#' + el.id).slice(0, 60);
        var c = typeof el.className === 'string' ? el.className.trim().split(/\s+/)[0] : '';
        return (c ? d + '.' + c : d).slice(0, 60);
      } catch (e) { return ''; }
    }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (!e.interactionId) return;
          n++;
          if (e.duration > worst) {
            worst = e.duration;
            w = { s: e.startTime, t: desc(e.target), et: e.name, d: Math.round(e.processingStart - e.startTime), pr: Math.round(e.processingEnd - e.processingStart), ps: Math.round(e.startTime + e.duration - e.processingEnd) };
          }
        });
      }).observe({ type: 'event', durationThreshold: 40, buffered: true });
    } catch (e) { return; /* older browsers: no sample, no harm */ }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (f) { frames.push(f); if (frames.length > 30) frames.shift(); });
      }).observe({ type: 'long-animation-frame', buffered: true });
    } catch (e) { /* Safari/Firefox: no script attribution */ }
    function culprit() {
      try {
        if (!w) return null;
        var best = null;
        for (var i = 0; i < frames.length; i++) {
          var f = frames[i];
          if (f.startTime > w.s + worst || f.startTime + f.duration < w.s) continue;
          (f.scripts || []).forEach(function (sc) { if (!best || sc.duration > best.duration) best = sc; });
        }
        if (!best) return null;
        var u = String(best.sourceURL || ''), m = u.match(/^https?:\/\/([^\/?#]+)([^?#]*)/);
        return { src: (m ? m[1] + m[2].slice(-40) : u.slice(0, 60)), inv: String(best.invoker || '').slice(0, 60), ms: Math.round(best.duration) };
      } catch (e) { return null; }
    }
    // Fire on visibilitychange→hidden as well as pagehide: app-switching on
    // mobile never fires pagehide, which biased the sample to desktop. Sent once.
    var sent = false;
    function sendInp() {
      if (sent || n === 0) return; sent = true;
      var pr = { v: Math.round(worst), n: n, pt: pageType() };
      if (w) { pr.tgt = w.t; pr.et = w.et; pr.d = w.d; pr.pr = w.pr; pr.ps = w.ps; }
      var c = culprit(); if (c) { pr.src = c.src; pr.inv = c.inv; pr.sms = c.ms; }
      track('inp_sample', pr); flush(true);
    }
    addEventListener('pagehide', sendInp);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendInp();
    });
  })();

  // ── page_leave + field web vitals (LL-0200..0203, LL-0207; 10 Oct 2026) ──
  // Sent once per page view, on the first visibilitychange→hidden or pagehide,
  // like inp_sample. page_leave { secs, visible_secs }; web_vitals { lcp, fcp,
  // ttfb (ms), cls, lcp_el }. Uses the internal track(), so these go to the
  // first-party collector only (not PostHog or GA4). The collector stores them
  // once 'page_leave' and 'web_vitals' are on its allow-list.
  (function () {
    // Times are performance.now() milliseconds, i.e. since the navigation started.
    function nowMs() { try { return performance.now(); } catch (e) { return 0; } }
    var visibleMs = 0;
    var visibleAt = -1; // set below once the activation time is known
    var lcp = 0, lcpEl = '', fcp = 0, ttfb = 0, cls = 0, winValue = 0, winFirst = 0, winLast = 0;
    function describe(el) {
      try {
        if (!el || !el.tagName) return '';
        var d = el.tagName.toLowerCase();
        if (el.id) return (d + '#' + el.id).slice(0, 60);
        var c = typeof el.className === 'string' ? el.className.trim().split(/\s+/)[0] : '';
        return (c ? d + '.' + c : d).slice(0, 60);
      } catch (e) { return ''; }
    }
    var activation = 0;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) { activation = nav.activationStart || 0; ttfb = Math.max(0, nav.responseStart - activation); }
    } catch (e) { /* no-op */ }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (e.name === 'first-contentful-paint') fcp = e.startTime; });
      }).observe({ type: 'paint', buffered: true });
    } catch (e) { /* no-op */ }
    try {
      new PerformanceObserver(function (list) {
        var es = list.getEntries(), e = es[es.length - 1];
        if (e) { lcp = e.startTime; lcpEl = describe(e.element); }
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) { /* no-op */ }
    try {
      // CLS as web-vitals defines it: the largest burst of shifts (gaps < 1 s, burst < 5 s).
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.hadRecentInput) return;
          if (winValue && e.startTime - winLast < 1000 && e.startTime - winFirst < 5000) {
            winValue += e.value;
          } else {
            winValue = e.value; winFirst = e.startTime;
          }
          winLast = e.startTime;
          if (winValue > cls) cls = winValue;
        });
      }).observe({ type: 'layout-shift', buffered: true });
    } catch (e) { /* no-op */ }
    if (document.visibilityState === 'visible') visibleAt = activation;
    var sent = false;
    function sendLeave() {
      if (sent) return;
      sent = true;
      try {
        var t = nowMs();
        if (visibleAt >= 0) { visibleMs += t - visibleAt; visibleAt = -1; }
        var pt = pageType();
        track('page_leave', { secs: Math.round(Math.max(0, t - activation) / 1000), visible_secs: Math.round(visibleMs / 1000), pt: pt }, true);
        var v = { pt: pt, cls: Math.round(cls * 1000) / 1000 };
        if (lcp) { v.lcp = Math.round(lcp); if (lcpEl) v.lcp_el = lcpEl; }
        if (fcp) v.fcp = Math.round(fcp);
        if (ttfb) v.ttfb = Math.round(ttfb);
        track('web_vitals', v, true);
        flush(true);
      } catch (e) { /* no-op */ }
    }
    addEventListener('pagehide', sendLeave);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendLeave();
      else if (visibleAt < 0) visibleAt = nowMs();
    });
  })();
})();
